// @file Transforms the descriptions of the shapes in the prompt to simple descriptions.
// Copied from https://github.com/tldraw/ai/blob/5740fcc4ccb30fac062d86f0b130078dbcebba7a/example/client/transforms/ShapeDescriptions.ts
import type { TLAiChange } from '@tldraw/ai'
import { TldrawAiTransform } from '@tldraw/ai'

export class ShapeDescriptions extends TldrawAiTransform {
  override transformChange = (change: TLAiChange): TLAiChange => {
    switch (change.type) {
      case 'createShape': {
        const { shape, description } = change

        if (description !== '') {
          shape.meta = {
            ...shape.meta,
            description,
          }
        }
        return {
          ...change,
          shape,
        }
      }
      case 'updateShape': {
        const { shape, description } = change

        if (description !== '') {
          shape.meta = {
            ...shape.meta,
            description,
          }
        }
        return {
          ...change,
          shape,
        }
      }
      default: {
        return change
      }
    }
  }
}
